import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { ERROR_STATUSES } from "@/api/types";
import { SystemPage } from "@/features/system/system-page";
import { baseListSearch, optionalEnum, optionalString } from "@/lib/list-state";

export const Route = createFileRoute("/_authenticated/system/")({
  validateSearch: z.object({
    ...baseListSearch,
    tab: optionalEnum(["health", "errors", "events"] as const),
    error: optionalString,
    service: optionalString,
    severity: optionalEnum(["CRITICAL", "ERROR", "WARNING"] as const),
    status: optionalEnum(ERROR_STATUSES),
    organizationId: optionalString,
  }),
  head: () => ({ meta: [{ title: "System · Rogue Admin" }] }),
  component: SystemPage,
});
